import React from 'react'
import { Typography, Grid, Container } from '@material-ui/core';
import '../EndOfFlowPage.scss'

const Congratulations = () => {
    return (
            <div>
                <Typography class="congrats-main-title">We've got <br />you <span className='super-light-blue margin-bottom-large'>covered!</span></Typography>
                <Typography variant='body1' className='white bold margin-bottom-medium'>Your order is now complete!</Typography>
                <Typography variant='body1' className='white margin-bottom-medium'>Your policy will be sent to your <span className='bold'>email</span> shortly</Typography>
            </div>
    )

}

export default Congratulations